<template>
  <div>
    <WsMain v-if="isLoading.modelData">
      <v-skeleton-loader
        type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
      ></v-skeleton-loader>
    </WsMain>
    <WsMain v-else>
      <WsBreadCrumbs :items="_breadcrumbsItems"></WsBreadCrumbs>
      <WsTitle>建立評析鑑別</WsTitle>
      <div class="ws-content-section">
        <WsCRUD
          v-if="isMounted"
          isMultiSelect
          liveSearching
          modelName="article_version"
          :fields="fields"
          :showFields="showFields"
          :getParams="$_getParams"
          :inRowBtnUpdate="false"
          :inRowBtnDelete="false"
          :showExpand="false"
          :hasMultiDeleteBtn="false"
          :isCreatable="false"
          :displayHideFields='displayHideFields'
          @selected-changed="$_onSelectedChanged"
        />
        <ValidationObserver ref="form" >
          <v-form
            ref="createForm"
            @submit.prevent
          >
            <div class="ws-content-section" >
              <div class="ws-content-section__secondary">
                <WsStateContentBlock
                  :type="idtfFields.type"
                  :floors="idtfFields.floors"
                  :locale="_selectingLocale"
                  :modedFields="_updateFields"
                  :updateData="idtfOwners"
                  @input="$_onInput"
                />
                  <!-- @input="$_onInput($event)" -->
              </div>
            </div>
          </v-form>
        </ValidationObserver>
      </div>
      <WsMainBottomNav>
      <WsBtn
        outlined
        color="textSecondary"
        :loading="isLoading.submit"
        @click="$router.go(-1)"
      >取消</WsBtn>
      <WsBtn
        :disabled="!_isValidate"
        :loading="isLoading.submit"
        @click="$_onSubmit"
      >送出</WsBtn>
    </WsMainBottomNav>
    </WsMain>
  </div>
</template>

<script>
import S_act from '@/services/api/v1/act';
import S_idtf from '@/services/api/v1/idtf';
import M_articleIdtfAssignment from '@/models/article_idtf_assignment';

export default {
  data() {
    return {
      isLoading: {
        modelData: false,
        submit: false,
      },
      modelData: null,
      isMounted: false,
      fields: M_articleIdtfAssignment.fields,
      showFields: [
        'no_text',
      ],
      idtfFields: {
        type: 'infoCard',
        floors: [
          {
            title: '鑑別設定',
            fields: [
              'idtf_owners',
              'idtf_backups',
              'idtf_reviewers',
              'overall_owners',
            ],
          },
        ],
      },
      idtfOwners: {},
      selected: [],
      displayHideFields: [
        'icon',
        'updated_admin',
        'updated_at',
        'isInRowBtnCheckPassDisabled',
        'isInRowBtnCheckFailDisabled',
        'isInRowBtnUpdateDisabled',
        'act_cnt_check_result',
        'act_cnt_updated_at',
        'act_cnt_updated_admin',
        'act_cnt_final_reviewed_at',
        'act_cnt_final_reviewer',
        'idtf_check_result',
        'idtf_updated_admin',
        'idtf_updated_at',
        'idtf_final_reviewer',
        'idtf_final_reviewed_at',
        'official_comment',
        'btnLoading',
        'dot',
        'has_released_first',
        'has_idtf',
        'idtf_owners',
        'idtf_backups',
        'idtf_reviewers',
        'overall_owners',
        'overall_review_result',
        'overall_review_remark',
        'idtf_review_result',
        'idtf_final_review_remark',
        'idtf_overall_reviewed_at',
        'idtf_overall_reviewer',
        'overall_review_updated_at',
        'overall_review_updated_admin',
        'idtf_remark',
        'act_cnt_final_review_remark',
        'act_cnt_review_result',
      ]
    };
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _actId() {
      return this.$route.params.id;
    },
    _breadcrumbsItems() {
      let actName = this.modelData
        ? this.modelData.last_version.locales[this._selectingLocale].name || '法規'
        : '法規';
      return [
        { text: '法規', to: '/act' },
        { text: actName, to: `/act/${this._actId}` },
        { text: '建立評析鑑別', disabled: true },
      ];
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
    _isValidate() {
      const { idtf_owners, idtf_backups, idtf_reviewers, overall_owners } = this.idtfOwners;
      return idtf_owners && idtf_owners.length > 0 &&
        idtf_backups && idtf_backups.length > 0 &&
        idtf_reviewers && idtf_reviewers.length > 0 &&
        overall_owners && overall_owners.length > 0;
    },
  },
  async mounted() {
    await this.$_init();
    this.isMounted = true;
  },
  methods: {
    async $_init() {
      this.isLoading.modelData = true;
      this.modelData = await S_act.show(this._actId);
      this.isLoading.modelData = false;
    },
    $_getParams() {
      const actVersionId = this.modelData.last_version.id;
      return {
        order_way: 'asc',
        order_by: 'no_number',
        lang: 'tw',
        act_versions: actVersionId,
        act_version: actVersionId
      }
    },
    $_onInput($event) {
      this.idtfOwners = {
        ...this.idtfOwners,
        ...$event,
      };
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) return;
      this.isLoading.submit = true;
      try {
        const idtfId = await this.$_createIdtfAssignment();
        await this.$_createActIdtfItems(idtfId);
        await this.$_createArticleIdtfItems(idtfId);
        this.$router.push(`/act/${this._actId}`);
      } catch (error) {
        alert(error);
      } finally {
        this.isLoading.submit = false;
      }
    },
    $_onSelectedChanged($event) {
      this.selected = $event;
    },
    async $_createIdtfAssignment() {
      const { idtf_owners, idtf_backups, idtf_reviewers, overall_owners } = this.idtfOwners;
      const data = {
        act_version: this.modelData.last_version.id,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
        overall_owners,
      };
      const { id } = await S_idtf.createCommentIdtfAssignment(data);
      return id;
    },
    async $_createActIdtfItems(idtfId) {
      const data = {
        act_version: this.modelData.last_version.id,
      };
      await S_idtf.createIdtfItem(data, idtfId);
    },
    async $_createArticleIdtfItems(idtfId) {
      if (!this.selected || this.selected.length === 0) return;
      await Promise.all(
        this.selected.map(item => S_idtf.createIdtfItem({
          article_version: item.id
        }, idtfId))
      );
    }
  },
}
</script>